export enum TaxesTypes {
  Transportation = 'transportation-taxes',
  Food = 'food-taxes',
  PromisedSchoolTaxes = 'promised-school-taxes',
}
